export default {
  meta: {
    title: '摄像头详情'
  }
};
